import useTranslation from 'next-translate/useTranslation';
import { ComboType, ComboVariant } from '@/models/Combo';
import { ProductListTypeEnum } from '@/utils/analytics/types';
import Paragraph, { VARIANT } from '../../Paragraph';
import ComboVariantCard from './ComboVariantCard';
interface Props {
  productVariants: ComboVariant[];
  listType?: ProductListTypeEnum;
  position?: number;
  onContine?: VoidFunction;
  componentName?: string;
  componentId?: string | number;
  isWishlist?: boolean;
  product?: ComboType;
}
const ComboVariantList = ({
  productVariants,
  listType,
  position,
  onContine,
  componentName = '',
  componentId = '',
  isWishlist,
  product
}: Props) => {
  const productName = product?.name;
  const {
    t
  } = useTranslation('address');
  return <>
      <header>
        <Paragraph variant={VARIANT.BIG} isHighlighted className="text-neutral-90" data-sentry-element="Paragraph" data-sentry-source-file="ComboVariantList.tsx">
          {productName}
        </Paragraph>
      </header>
      <section className="flex flex-col gap-3 mt-4">
        {productVariants.map(variant => <ComboVariantCard key={variant.id} productVariant={variant} listType={listType} position={position} componentName={componentName} componentId={componentId} isWishlist={isWishlist} product={product} />)}
      </section>
      <button className="flex flex-1 justify-center items-center bg-primary-100 mt-4 py-3 rounded-lg w-full" onClick={() => onContine?.()}>
        <p className="font-medium text-white text-lg">{t('continue')}</p>
      </button>
    </>;
};
export default ComboVariantList;